export default __webpack_public_path__ + "static/media/logo-light.24f19705.svg";